var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreaterThan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.15 0.900096L15.275 9.5C15.375 9.6 15.4457 9.70833 15.487 9.825C15.529 9.94167 15.55 10.0667 15.55 10.2C15.55 10.3333 15.529 10.4583 15.487 10.575C15.4457 10.6917 15.375 10.8 15.275 10.9L2.15 19.1251C1.91667 19.3584 1.625 19.4751 1.275 19.4751C0.924999 19.4751 0.625 19.3501 0.375 19.1001C0.125 18.8501 8.01375e-08 18.5584 1.09278e-07 18.2251C1.38419e-07 17.8918 0.125 17.6001 0.375 17.3501L12.425 10.2L0.375001 2.6501C0.141668 2.41676 0.0250011 2.12943 0.0250012 1.7881C0.0250012 1.4461 0.150001 1.1501 0.400001 0.900096C0.650001 0.650096 0.941668 0.525096 1.275 0.525096C1.60833 0.525096 1.9 0.650096 2.15 0.900096Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterThan);
export default __webpack_public_path__ + "static/media/greater-than.7bbddabe43fd58417c8e4ac6771ce50a.svg";
export { ForwardRef as ReactComponent };